import React, { FC } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Table } from '@wmgtech/legato'

import { Chart } from 'shared/__gql-types'
import { cn } from 'shared/utils'
import { getChartAttr } from 'shared/utils/chartConfig'
import { getCoverImagePath } from 'shared/utils/getCoverImagePath'
import { capitalizeFirstLetter } from 'shared/utils/capitalizeFirstLetter'

import { TopChartingProductsProps } from './TopChartingProducts.props'
import './Products.scss'

export const TopChartingProducts: FC<TopChartingProductsProps> = ({ products }) => {
  const navigate = useNavigate()

  return (
    <div className="products">
      <h3>Top Charting Products</h3>
      <Table
        rowKey={(record: Chart) => record.id}
        key={products.length}
        data={products}
        condensed
        pagination={false}
        onRow={(row) => ({
          onClick: () => navigate(`/projects/${row.campaign_id}`)
        })}
        columns={[
          {
            key: 'chart',
            dataIndex: 'chart',
            sortable: false,
            render: (value: string) => <div className={cn(getChartAttr(value)?.icon)} />
          },
          {
            title: 'Type',
            key: 'configuration',
            dataIndex: 'configuration',
            sortable: false,
            render: (value: string) => <>{capitalizeFirstLetter(value)}</>
          },
          {
            key: 'rank',
            dataIndex: 'rank',
            sortable: false
          },
          {
            title: 'Artist -  Product Name',
            key: 'name',
            dataIndex: 'name',
            sortable: false,
            render: (value: string, product: Chart) => (
              <div>
                <b>
                  {product.artist}
                  {' - '}
                </b>
                <b>{product.title}</b>
              </div>
            )
          },
          {
            key: 'parent_id',
            dataIndex: 'parent_id',
            sortable: false,
            render: (value: string, product: Chart) => (
              <img
                className="products-cover"
                alt={product.title || ''}
                src={getCoverImagePath(product.parent_id || '')}
              />
            )
          }
        ]}
      />
      <Link className="products-link" to="/charts">
        <b>View all</b>
      </Link>
    </div>
  )}
